<script setup lang="ts">
import { CheckCheck, Copy } from 'lucide-vue-next'
import type { WebChatMessage } from '~/types/web-chat'

const props = defineProps<{
  msg: WebChatMessage
}>()

const { t } = useI18n()

const copied = ref(false)

async function copyMessage() {
  await navigator.clipboard.writeText(props.msg.content)
  copied.value = true
  setTimeout(() => { copied.value = false }, 1500)
}
</script>

<template>
  <div class="flex items-center gap-0.5 mt-0.5 opacity-0 group-hover/msg:opacity-100 transition-opacity">
    <button
      type="button"
      class="p-1 rounded-md hover:bg-accent-lighter text-muted-foreground hover:text-foreground transition-colors"
      :title="t('common.copyToClipboard')"
      @click="copyMessage"
    >
      <CheckCheck v-if="copied" class="h-3 w-3 text-success" />
      <Copy v-else class="h-3 w-3" />
    </button>
  </div>
</template>
